import {Reminder, ReminderPosition, ReminderProps} from './Reminder'
import {Accessor, createSignal, For, Setter} from 'solid-js'
import {useDispatch} from '../../store'
import {removeNotificationById} from '@te/volt-store/lib/actions'
import { ReminderContext } from './ReminderContext'
import { useSelector } from '../../store'

export interface ReminderProviderProps {
    toastPosition?: ReminderPosition | any
    children: any
}

export const ReminderProvider = (props: ReminderProviderProps) => {
    const [autoClosed, setAutoClosed] = createSignal<boolean>(false)
    const [toastDetails, setToastDetails] = createSignal<ReminderProps[]>([])
    const [toastsMarkedForDeletion, setToastsMarkedForDeletion] = createSignal<number[]>([])
    const [isReminderShow, setIsReminderShow] = createSignal<boolean>(false)
    const [shownReminders, setShownReminders] = createSignal<any>([])
    const [focusedReminderId, setFocusedReminderId] = createSignal<any>([])
    const [showReminderPinPopUp, setshowReminderPinPopUp] = createSignal({})

    const programsState = useSelector((s: any) => s.programs)
    const channelsState = useSelector((s: any) => s.channels)
    const dispatch = useDispatch()
    const timeoutHandle: any = {}

    const clearTimeOutHandler = (id: any) => {
        if (id in timeoutHandle) {
            clearTimeout(timeoutHandle[id])
            delete timeoutHandle[id]
        }
    }
    const setTimeoutHandler = (id: any, code: any, time: any) => {
        clearTimeOutHandler(id)
        timeoutHandle[id] = setTimeout(code, time)
    }

    const autoCloseToast = (id: number, popUpId: any, life: number = 5000, props: any) => {
        setTimeoutHandler(id, () => {
            onReminderClose(id, props, popUpId)
            setAutoClosed(true)
        }, life)
    }

    const snoozeReminderAvailbility = (startTime: any) => {
        return new Date().getTime() < new Date(startTime).getTime() ? true : false
    }

    const checkfocusedId = (eventId: any) => {
        const program = programsState()?.[eventId]
        const channel = channelsState?.()?.data?.[program?.channelId]
        const isKidsProfile = localStorage.getItem("isKidsProfile")
        if (isKidsProfile === 'true' && !channel?.isKidsChannel) {
            if (snoozeReminderAvailbility(program?.startTime))
                return "snooze_reminder" + eventId
            return "stop_reminder" + eventId
        } else {
            return 'reminder_watch_episode' + eventId
        }
    }

    const showReminder = (Reminder: ReminderProps | ReminderProps[]) => {
        if (Array.isArray(Reminder)) {
            const newToasts: ReminderProps[] = Reminder.map((t: ReminderProps) => {
                const id = new Date().getTime()
                !t.sticky && autoCloseToast(id, t.id, t.life, t)
                setShownReminders([...shownReminders(), t.id])
                const focusedId = checkfocusedId(t.eventId)
                setFocusedReminderId([...focusedReminderId(), focusedId])
                setIsReminderShow(true)
                return {...t, description: t.description, id}
            })
            setToastDetails([...toastDetails(), ...newToasts])
        } else {
            const id = new Date().getTime()
            setShownReminders([...shownReminders(), Reminder.id])
            const focusedId = checkfocusedId(Reminder.eventId)
            setFocusedReminderId([...focusedReminderId(), focusedId])
            setIsReminderShow(true)
            !Reminder.sticky && autoCloseToast(id, Reminder.id, Reminder.life, Reminder)
            setToastDetails([...toastDetails(), {...Reminder, description: Reminder.description, id}])
        }
    }

    const onReminderClose = (id: number,props: any, popUpId?: number) => {
        setToastsMarkedForDeletion([...toastsMarkedForDeletion(), id])
        clearTimeOutHandler(id)
        setTimeout(() => {
            const toasts = [...toastDetails()]
            toasts.splice(
                toastDetails().findIndex(t => t.id === id),
                1
            )
            setToastDetails(toasts)

            const toastDeletion = [...toastsMarkedForDeletion()]
            toastDeletion.splice(
                toastDeletion.findIndex(t => t === id),
                1
            )
            setToastsMarkedForDeletion(toastDeletion)
            dispatch(removeNotificationById(popUpId))
            
            const tempFocus = [...focusedReminderId()]
            tempFocus.splice(
                tempFocus.findIndex(t => t === props.eventId),
                1
            )
            setFocusedReminderId(tempFocus)
            if(!document.getElementById('reminder-screen')) setIsReminderShow(false)
        }, 500)
        setTimeout(() => {
            const temp = [...shownReminders()]
            temp.splice(
                temp.findIndex(t => t === props.id),
                1
            )
            setShownReminders(temp)
        }, props?.life)
        props.onReminderHandleFocus && props.onReminderHandleFocus()
    }

    return (
        <ReminderContext.Provider
            value={{
                show: showReminder,
                isReminderShow: isReminderShow,
                shownReminders: shownReminders,
                focusedReminderId: focusedReminderId,
                setshowReminderPinPopUp,
                showReminderPinPopUp
            }}
        >
            {props.children}
            <For each={toastDetails()}>
                {(reminder: ReminderProps, index) => {
                    return (
                        <Reminder
                            {...reminder}
                            position={props.toastPosition}
                            index={index()}
                            className={toastsMarkedForDeletion().includes(reminder.id || 0) ? 'deletion' : ''}
                            onClose={(id: any, props: any) => onReminderClose(id, props)}
                            autoClosed={autoClosed()}
                            setAutoClosed={setAutoClosed}
                        />
                    )
                }}
            </For>
        </ReminderContext.Provider>
    )
}

export interface ReminderProviderBehavior {
    show: (reminder: ReminderProps) => any
    isReminderShow: Accessor<boolean>
    shownReminders: Accessor<any[]>
    focusedReminderId: Accessor<any[]>
    setshowReminderPinPopUp: Setter<any>
    showReminderPinPopUp: Accessor<any>
}
